import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';
const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del usuario
const idAdministrativo = cookie.get("idAdministrativo"); //declaramos una variable para usar la cookie del login

class SidebarVicerrectoradoAdm extends Component {

    componentDidMount() {
        // Get que devuelve los datos del usuario especificando un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const administrativo = res.data;
                this.setState({ administrativo });

                cookie.set('nombres', administrativo.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', administrativo.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (

            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal de Vicerrectorado Administrativo</p>
                        </div>

                        <Link to="/vicerrectoradoadm" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                        {/* Perfil */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfilVicerAdm"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfilVicerAdm">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoadm/VerPerfilVicerrAdm" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Matrículas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculasVicerAdm"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculasVicerAdm">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoadm/aprobarpagotransferencia" className="nav-sub-link">
                                        Pagos de Matrícula
                                    </Link>
                                    <Link to="/vicerrectoradoadm/cantidadmatri" className="nav-sub-link">
                                        Cantidad de Matriculados
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Colegiaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseColegiaturasVicerAdm"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Colegiaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseColegiaturasVicerAdm">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/vicerrectoradoadm/colegiaturasestcarreraciclogenvic"
                                        className="nav-sub-link"
                                    >
                                        Reporte de Colegiaturas (General)
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoadm/colegiaturastransfestcarreraciclo"
                                        className="nav-sub-link"
                                    >
                                        Reporte de Colegiaturas (Transferencias)
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoadm/colegiaturasEstColegUnPagoVic"
                                        className="nav-sub-link"
                                    >
                                        Pagos Ciclo Completo
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Departamentos */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseDepartamentosVicerAdm"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Departamentos
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseDepartamentosVicerAdm">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoadm/GestionDepartamentos" className="nav-sub-link">
                                        Gestión de Departamentos
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Notificaciones */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseNotificacionesVicerAdm"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Notificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseNotificacionesVicerAdm">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/vicerrectoradoadm/notificacionestudiante"
                                        className="nav-sub-link"
                                    >
                                        Notificaciones para Estudiantes
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarVicerrectoradoAdm);